module.exports = __webpack_public_path__ + "static/media/prop-9@2x.ab251235.png";